import React from "react";
import { Grid, TextField } from "@material-ui/core";
import get from "lodash/get";

class SubCategory extends React.Component {
  state = {};

  handleChange = ({ target: { name, value } }) => {
    this.setState({
      [name]: value
    });
  };

  render() {
    const { formik, avps, avpName } = this.props;    
    return (
      <Grid container classes={{ container: "FormGroup" }}>
        <Grid className="header_Striped_Left" item xs={12} />
        <Grid item xs={12} className="row">
          <div className="avp-section">
            <h4>{avpName}</h4>
            {Object.keys(avps).map(avp => (
              <TextField
                key={avp}
                label={avp}
                className="avps_FieldsTextarea avp-item"
                type="text"
                multiline
                rowsMax="10"
                margin="normal"
                name={`avps["Fund Information"]["Details"].${avpName}.${avp}`}
                defaultValue={get(avps, avp, "")}
                onChange={formik.handleChange}
              />
            ))}
          </div>
        </Grid>
      </Grid>
    );
  }
}

export default SubCategory;
